import React, { useState, useEffect } from 'react';
import { Input, Label } from "reactstrap";
import useApi from "../../hooks/useApi";

function ProjectAddress({formData, setFormData}) {
    // Disable warning since we are not using entered country value (yet)
    // eslint-disable-next-line
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [locality, setLocality] = useState('');
    // Disable warning since we are not using entered postcode (yet)
    // eslint-disable-next-line
    const [postcode, setPostcode] = useState('');
    const [addressLine1, setaddressLine1] = useState('');
    const [addressLine2, setaddressLine2] = useState('');
    //const [administrativeAreas, setAdministrativeAreas] = useState([]);
    const [selectedAdministrativeAreaId, setSelectedAdministrativeAreaId] = useState('');

    const countryApi = useApi('country');
    const administrativeAreaApi = useApi('administrativearea');

    useEffect(() => {
        countryApi.get();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const populateAdministrativeAreas = async (countryId) => {
        if (countryId) {
            administrativeAreaApi.get({countryId: countryId});
        }
    }

    const handleCountryChange = (e) => {
        let selectedOption = e.target.options[e.target.selectedIndex];
        let selectedCountryId = parseInt(selectedOption.value);
        let chosenCountry = countryApi.data?.find(country => country.id === selectedCountryId);
        if (chosenCountry) {
            setAddressDataToForm({
                ...formData,
                countryId: chosenCountry.id,
                administrativeAreaId: null,
                administrativeAreaName: null,
                locality: null,
                addressLine: null,
                addressLine2: null,
                postalCode: null
            });
            setSelectedCountry(chosenCountry);
            setSelectedAdministrativeAreaId('');
            populateAdministrativeAreas(chosenCountry.id);
            clearForm();
        }
    }

    const handleSelectedAdministrativeAreaChange = (e) => {
        setSelectedAdministrativeAreaId(e.target.value);
        let administrativeAreaOption = e.target.options[e.target.selectedIndex];
        setAddressDataToForm({
            ...formData,
            administrativeAreaId: administrativeAreaOption.value,
            administrativeAreaName: administrativeAreaOption.text,
            locality: null,
            addressLine: null,
            addressLine2: null,
            postalCode: null
        });

        clearForm();
    }

    const clearForm = () => {
        setLocality('');
        setaddressLine1('');
        setaddressLine2('');
        setPostcode('');
    }

    const setAddressDataToForm = (data) => {
        if (typeof setFormData === 'function') {            
            setFormData(
                formData => (data)
            );
        }
    }

    const handleLocalityChange = (e) => {
        setLocality(e.target.value);
        setAddressDataToForm({ ...formData, locality: e.target.value });
    }

    const handleAddressLine1Change = (e) => {
        setaddressLine1(e.target.value);
        setAddressDataToForm({ ...formData, addressLine: e.target.value });
    }

    const handleAddressLine2Change = (e) => {
        setaddressLine2(e.target.value);
        setAddressDataToForm({ ...formData, addressLine2: e.target.value });
    }

    const handlePostcodeChange = (e) => {
        setPostcode(e.target.value);
        setAddressDataToForm({ ...formData, postalCode: e.target.value });
    }

    const countryOptions = countryApi.data ? countryApi.data.map(
        (country) => <option key={country.id} value={country.id}>{country.name}</option>
    ) : [];

    var administrativeAreaOptions = administrativeAreaApi.data ? administrativeAreaApi.data.map(
        (administrativeArea) => 
            <option key={administrativeArea.id} value={administrativeArea.id}>
                {administrativeArea.name}
            </option>
    ) : [];
    
    return (
        <div>
            <div className="col-sm">
                <div>
                    <Label>Country</Label>
                </div>
                <Input type="select" defaultValue="" onChange={handleCountryChange}>
                    <option value="" disabled hidden>
                        {countryApi.loading
                            ? "Loading..."
                            : countryOptions.length
                                ? "Choose a country..."
                                : "No countries found"}
                    </option>
                    {countryOptions}
                </Input>
            </div>
            <div className="col-sm">
                <div>
                    <Label>Administrative Area</Label>
                </div>
                <Input type="select"
                    value={selectedAdministrativeAreaId}
                    onChange={handleSelectedAdministrativeAreaChange}
                    disabled={countryOptions.length === 0}>
                    <option value="" disabled hidden>
                        {administrativeAreaOptions.length === 0
                            ? ""
                            : "Choose the Administrative Area..."}
                    </option>
                    {administrativeAreaOptions}
                </Input>
            </div>
            <div className="col-sm">
                <div>
                    <Label>City</Label>
                </div>
                <div className="col-sm">
                    <Input type="text"
                        value={locality}
                        onChange={handleLocalityChange}
                        disabled={selectedAdministrativeAreaId === ''}
                    />
                </div>
            </div>
            <div className="col-sm">
                <div>
                    <Label>Address Line 1</Label>
                </div>
                <div className="col-sm">
                    <Input type="text"
                        value={addressLine1}
                        onChange={handleAddressLine1Change}
                        disabled={selectedAdministrativeAreaId === ''}
                    />
                </div>
            </div>
            <div className="col-sm">
                <div>
                    <Label>Address Line 2</Label>
                </div>
                <div className="col-sm text-end">
                    <Input type="text"
                        value={addressLine2}
                        onChange={handleAddressLine2Change}
                        disabled={selectedAdministrativeAreaId === ''}
                    />
                </div>
            </div>
            <div className="col-sm">
                <div>
                    <Label>ZIP / Postcode</Label>
                </div>
                <div className="col-sm text-end">
                    <Input type="text"
                        value={postcode}
                        onChange={handlePostcodeChange}
                        disabled={selectedAdministrativeAreaId === ''}
                    />
                </div>
            </div>
        </div>
    );
}

export default ProjectAddress;